/**
 * This is copied from src/core/support/CustomErrors.ts with some code from @intl/t
 * TODO: Find a way leverage code reuse
 */

type ExtractTokens<T extends string> = string extends T
  ? never
  : T extends `${infer _Start}{${infer Name}}${infer Rest}`
  ? Name | ExtractTokens<Rest>
  : never;

type MaybeValues<List extends string> = [List] extends [never]
  ? []
  : [values: { [K in List]: unknown }];

export class ValidationError<S extends string> extends Error {
  // This can be used for i18n
  originalMessage: [string, Record<string, string> | null];

  constructor(message: S, ...[params]: MaybeValues<ExtractTokens<S>>) {
    const resolvedMessage = params ? resolveMessage(message, params) : message;
    super(resolvedMessage);
    this.originalMessage = [message, normalizeParams(params)];
  }

  get name() {
    return this.constructor.name;
  }

  get [Symbol.toStringTag]() {
    return this.constructor.name;
  }
}

function resolveMessage(message: string, params: ObjectOf<unknown>) {
  return message.replace(/\{(.*?)\}/g, (match: string, word: string) => {
    return toString(params[word]) ?? match;
  });
}

function normalizeParams(
  params: ObjectOf<unknown> | undefined,
): ObjectOf<string> | null {
  if (!params) {
    return null;
  }
  const normalized: ObjectOf<string> = {};
  for (const [key, value] of Object.entries(params)) {
    normalized[key] = toString(value) ?? '';
  }
  return normalized;
}

function toString(input: unknown) {
  return input != null ? String(input) : undefined;
}
